import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Login from "pages/Login";
import ProductsAndCoverage from "pages/ProductsAndCoverage";
import ManageOrders from "pages/ManageOrders";
import Tracking from "pages/Tracking";
import ReportsDashboard from "pages/ReportsDashboard";

import Sidebar from "components/Sidebar";

import ManageUsers from "pages/ManageUsers";
import DealerById from "pages/DealerById";
import Chat from "pages/Chat";
import WebViewMobile from "pages/WebViewMobile";
import ForgotPassword from "pages/ForgotPassword";
import ProtectedRoute from "./ProtectedRoute";
import UnprotectedRoute from "./UnprotectedRoute";
import ReportsOrderHistory from "../pages/ReportsOrderHistory";
import ReportsPayments from "pages/ReportsPayments";
import ScheduleOrders from "pages/ScheduleOrders";
import ReportsSales from "pages/ReportsSales";

const RootRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<UnprotectedRoute />}>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route path="/webview" element={<WebViewMobile />} />
        </Route>

        <Route element={<ProtectedRoute />}>
          <Route element={<Sidebar />}>
            <Route path="/orders/chat" element={<Chat />} />
            <Route
              path="settings/products-and-coverage"
              element={<ProductsAndCoverage />}
            />
            <Route path="settings/users" element={<ManageUsers />} />
            <Route path="orders/manage" element={<ManageOrders />} />
            <Route path="orders/schedule" element={<ScheduleOrders />} />
            <Route path="orders/rastreamento" element={<Tracking />} />
            <Route path="dealers/info" element={<DealerById />} />
            <Route path="reports/dashboard" element={<ReportsDashboard />} />
            <Route path="reports/sales" element={<ReportsSales />} />
            <Route
              path="reports/order-history"
              element={<ReportsOrderHistory />}
            />
            <Route path="reports/payments" element={<ReportsPayments />} />
          </Route>
        </Route>

        {/*
         *
         * Criar página 404
         *
         */}
        <Route path="*" element={<span> 404 - Not Found </span>} />
      </Routes>
    </BrowserRouter>
  );
};

export default RootRoutes;
